import React, { Component } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';
import AuthHelper from '../../../Helper/AuthHelper';

import ThingsToSelect from '../../../Helper/ThingsToSelect';

import InputRow from '../../../Components/InputRow';
import LoadingCenter from '../../../Components/LoadingCenter';

import AppConfig from '../../../AppConfig';

export default class SearchRestaurants extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			countries: [],
		};
	}

	componentDidMount = async () => {
		let requestCountries = APIGet('countries');
		requestCountries = await requestCountries;
		if (APIHelper.handleAPIResponse(this, requestCountries)) {
			const countries = ThingsToSelect(requestCountries.data, true);
			console.log('countries: ', countries);
			this.setState({
				isLoading: false,
				countries,
			});
		} else {
			toast.error('ไม่สามารถดึงข้อมูลได้');
		}
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		const { country, city, name } = this.props.keywords;
		return (
			<div className="columns">
				<div className="column is-3">
					<label className="label">ประเทศ</label>
					<Select
						name="country"
						value={country}
						clearable={false}
						onChange={value => this.props.onSearchChange('country', value)}
						options={this.state.countries}
					/>
				</div>
				<div className="column is-3">
					<InputRow
						title="เมือง"
						labelSize="s"
						placeholder="เมือง"
						keyProps="city"
						value={city}
						onInputChange={this.props.onSearchChange}
						disabled={false}
						onKeyPress={this.handleKeyPress}
					/>
				</div>
				<div className="column is-3">
					<InputRow
						title="ชื่อร้าน"
						labelSize="s"
						placeholder="ชื่อร้าน"
						keyProps="name"
						value={name}
						onInputChange={this.props.onSearchChange}
						disabled={false}
						onKeyPress={this.handleKeyPress}
					/>
				</div>
				<div className="column is-3" style={{ paddingTop: 44 }}>
					<button className="button is-info" onClick={this.props.onClick}>
						Filter
					</button>
				</div>
			</div>
		);
	}
}
